import { getAnalyticsClient } from '@carvana/analytics';
import SafeBaseClient from './SafeBaseClient';

function getClient(id) {
  return getAnalyticsClient(
    'dataLayer',
    `https://www.googletagmanager.com/gtm.js?id=${id}`
  );
}

export default class GoogleTagManagerClient extends SafeBaseClient {
  constructor(config) {
    super('gtm', config);
  }

  trackEvent = async (eventName, eventData = {}, log, noPublish) => {
    const trackConversionGoogleTagManager = await getClient(this.config.id);

    if (trackConversionGoogleTagManager) {
      if (log) {
        log('[Analytics_GoogleTagManager_Event]', { eventName, eventData });
      }

      if (!noPublish) {
        trackConversionGoogleTagManager.push({ ...eventData });
      }
    }
  };

  trackUser = async (eventName, eventData = {}, log, noPublish) => {
    const trackConversionGoogleTagManager = await getClient(this.config.id);

    const { userId } = eventData;
    if (trackConversionGoogleTagManager) {
      if (log) {
        log('[Analytics_GoogleTagManager_User]', { eventName, eventData });
      }

      if (!noPublish) {
        trackConversionGoogleTagManager.push({ uid: userId });
      }
    }
  };
}
